'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../aviary-core/dist/cjs/index.cjs');
var React = require('react');
var InternalInputIcon_web = require('../../internal/InternalInputIcon/InternalInputIcon.web.cjs');
var InternalTextInput_web = require('../../internal/InternalTextInput/InternalTextInput.web.cjs');

/**
 * SearchInput component is used to display a search input field
 *
 * {@link https://aviary.fullscript.io/latest/components/search-input/web-ANZCDVBN | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/SearchInput/SearchInput.web.tsx| View in GitLab}

 *
 * @scope Core
 */ const SearchInput = ({ value, placeholder = "Search", onClearIconClick, disabled, size = "medium", isFocused = false, onDebouncedChange, ...rest })=>{
    const inputRef = React.useRef(null);
    const debouncedCallback = index.useDebounce((inputVal)=>{
        if (onDebouncedChange) {
            onDebouncedChange(inputVal);
        }
    }, 400);
    React.useEffect(()=>{
        if (onDebouncedChange) {
            debouncedCallback(value);
            return ()=>debouncedCallback.cancel();
        }
    }, [
        value
    ]);
    React.useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current.focus();
        }
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx(InternalTextInput_web.InternalTextInput, {
        "data-testid": "aviary-search-input",
        type: "search",
        hideLabel: true,
        placeholder: placeholder,
        value: value,
        disabled: disabled,
        rightContent: value && !disabled && /*#__PURE__*/ jsxRuntime.jsx(InternalInputIcon_web.InternalInputIcon, {
            icon: "close",
            "aria-label": "Clear",
            onClick: onClearIconClick
        }),
        leftContent: /*#__PURE__*/ jsxRuntime.jsx(InternalInputIcon_web.InternalInputIcon, {
            icon: "search",
            "aria-label": "Search"
        }),
        size: size,
        ref: inputRef,
        ...rest
    });
};

exports.SearchInput = SearchInput;
//# sourceMappingURL=SearchInput.web.cjs.map
